// src/components/BusinessRegSteps/Step2ContactLocation.js
import React from 'react';
import { MapPinIcon, PhoneIcon, GlobeAltIcon } from '@heroicons/react/24/outline';

const Step2ContactLocation = ({ formData, updateFormData }) => {
    const countries = [
        { value: 'South Africa', label: 'South Africa' },
        { value: 'United States', label: 'United States' },
        { value: 'United Kingdom', label: 'United Kingdom' },
        { value: 'Australia', label: 'Australia' },
        { value: 'Canada', label: 'Canada' },
        { value: 'Germany', label: 'Germany' },
        { value: 'France', label: 'France' },
        { value: 'India', label: 'India' },
        { value: 'Brazil', label: 'Brazil' },
        { value: 'Mexico', label: 'Mexico' },
        { value: 'Japan', label: 'Japan' },
        { value: 'China', label: 'China' },
        // Add more countries as needed
    ];

    return (
        <fieldset className="border p-4 rounded-md space-y-4">
            <legend className="text-lg font-medium text-gray-900 flex items-center">
                <MapPinIcon className="h-6 w-6 text-indigo-500 mr-2" />
                Step 2: Contact & Location
            </legend>

            {/* Street Address */}
            <div>
                <label htmlFor="street-address" className="block text-sm font-medium text-gray-700">Street Address</label>
                <input
                    id="street-address"
                    name="street-address"
                    type="text"
                    required
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm p-2"
                    placeholder="e.g., 123 Main St"
                    value={formData.streetAddress}
                    onChange={(e) => updateFormData('streetAddress', e.target.value)}
                />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label htmlFor="city" className="block text-sm font-medium text-gray-700">City</label>
                    <input
                        id="city"
                        name="city"
                        type="text"
                        required
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm p-2"
                        placeholder="e.g., Johannesburg"
                        value={formData.city}
                        onChange={(e) => updateFormData('city', e.target.value)}
                    />
                </div>
                <div>
                    <label htmlFor="state-province" className="block text-sm font-medium text-gray-700">State / Province (Optional)</label>
                    <input
                        id="state-province"
                        name="state-province"
                        type="text"
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm p-2"
                        placeholder="e.g., Gauteng"
                        value={formData.stateProvince}
                        onChange={(e) => updateFormData('stateProvince', e.target.value)}
                    />
                </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label htmlFor="postal-code" className="block text-sm font-medium text-gray-700">Postal Code</label>
                    <input
                        id="postal-code"
                        name="postal-code"
                        type="text"
                        required
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm p-2"
                        placeholder="e.g., 2000"
                        value={formData.postalCode}
                        onChange={(e) => updateFormData('postalCode', e.target.value)}
                    />
                </div>
                <div>
                    <label htmlFor="country" className="block text-sm font-medium text-gray-700">Country</label>
                    <select
                        id="country"
                        name="country"
                        required
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm p-2 bg-white"
                        value={formData.country}
                        onChange={(e) => updateFormData('country', e.target.value)}
                    >
                        {countries.map((c) => (
                            <option key={c.value} value={c.value}>
                                {c.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Business Phone Number */}
            <div>
                <label htmlFor="business-phone" className="block text-sm font-medium text-gray-700">Business Phone Number</label>
                <div className="relative mt-1">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <PhoneIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </div>
                    <input
                        id="business-phone"
                        name="business-phone"
                        type="tel"
                        required
                        className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        placeholder="e.g., +27 11 123 4567"
                        value={formData.businessPhone}
                        onChange={(e) => updateFormData('businessPhone', e.target.value)}
                    />
                </div>
            </div>

            {/* Business Website */}
            <div>
                <label htmlFor="business-website" className="block text-sm font-medium text-gray-700">Business Website (Optional)</label>
                <div className="relative mt-1">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <GlobeAltIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </div>
                    <input
                        id="business-website"
                        name="business-website"
                        type="url"
                        className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        placeholder="e.g., https://myawesomeshop.com"
                        value={formData.businessWebsite}
                        onChange={(e) => updateFormData('businessWebsite', e.target.value)}
                    />
                </div>
            </div>
        </fieldset>
    );
};

export default Step2ContactLocation;